import { PropsWithChildren } from 'react'

import { combineClassnames } from 'app/common/presentation'

import styles from './Section.module.scss'

interface SettingsSectionProps extends PropsWithChildren {
  contentClassName: string
  description: string
  title: string
  variant?: 'danger' | 'default'
}

export const SettingsSection = ({
  children,
  contentClassName,
  description,
  title,
  variant = 'default',
}: SettingsSectionProps) => (
  <div className={styles.settingsSection}>
    <div className={styles.sectionHeader}>
      <h2>{title}</h2>
      <p>{description}</p>
    </div>
    <div className={combineClassnames(styles.content, contentClassName)} data-variant={variant}>
      {children}
    </div>
  </div>
)
